import { render, staticRenderFns } from "./ErrorPopup.vue?vue&type=template&id=3279f201&"
import script from "./ErrorPopup.vue?vue&type=script&lang=js&"
export * from "./ErrorPopup.vue?vue&type=script&lang=js&"
import style0 from "./ErrorPopup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports